import React, { Component } from 'react';

const Store = class Store extends Component{
  render(){
    return <div>Store</div>
  }
}

export default Store;


// WEBPACK FOOTER //
// ./src/containers/application/Store.js